import Axios, { AxiosInstance } from "axios";
import { UsersApi } from "@/api/api/users-api";
import { CompanyApi } from "@/api/api/company-api";
import { CourseApi } from "@/api/api/course-api";
import { CourseLectureApi } from "@/api/api/course-lecture-api";
import { LectureApi } from "@/api/api/lecture-api";
import { LectureExtraMaterialApi } from "@/api/api/lecture-extra-material-api";
import { LecturePageApi } from "@/api/api/lecture-page-api";
import { LectureSlideApi } from "@/api/api/lecture-slide-api";
import { LectureVideoApi } from "@/api/api/lecture-video-api";
import { AccessCheckApi } from "@/api/api/access-check-api";
import { TestApi } from "@/api/api/test-api";
import { TestPassApi } from "@/api/api/test-pass-api";
import { VideoApi } from "@/api/api/video-api";
import { PracticeApi } from "@/api/api/practice-api";
import { BBBWebinarApi } from "@/api/api/bbbwebinar-api";
import { CategoryApi } from "@/api/api/category-api";
import { CompanyFileApi } from "@/api/api/company-file-api";
import { FileApi } from "@/api/api/file-api";
import { ThirdPartyWebinarApi } from "@/api/api/third-party-webinar-api";
import { UserFileApi } from "@/api/api/user-file-api";
import { WebinarApi } from "@/api/api/webinar-api";
import { LearningRequestApi } from "@/api/api/learning-request-api";
import { EmployeeApi } from "@/api/api/employee-api";
import { ContractorApi } from "@/api/api/contractor-api";
import { ActApi } from "@/api/api/act-api";
import { BillApi } from "@/api/api/bill-api";
import { ContractApi } from "@/api/api/contract-api";
import { EducationProtocolApi } from "@/api/api/education-protocol-api";
import { EnrollmentOrderApi } from "@/api/api/enrollment-order-api";
import { ExpulsionOrderApi } from "@/api/api/expulsion-order-api";
import { FinalDocumentApi } from "@/api/api/final-document-api";
import { ApplicationApi } from "@/api/api/application-api";
import { ProfessionalActivityTaxonomyApi } from "@/api/api/professional-activity-taxonomy-api";
import { ProfessionalProgramTaxonomyApi } from "@/api/api/professional-program-taxonomy-api";
import { SpecialtyTaxonomyApi } from "@/api/api/specialty-taxonomy-api";
import { WidgetApi } from "@/api/api/widget-api";
import { DocTemplateApi } from "@/api/api/doc-template-api";
import { DocumentTypeTaxonomyApi } from "@/api/api/document-type-taxonomy-api";
import { DiskApi as DiskApiV2 } from "@/api-v2/files/api/disk-api";
import { FileApi as FileApiV2 } from "@/api-v2/files/api/file-api";
import { ConvertApi } from "@/api-v2/files/api/convert-api";
import { GlobalApi as GlobalApiV2 } from "@/api-v2/settings-storage/api/global-api";
import { CompanyApi as CompanyApiV2 } from "@/api-v2/settings-storage/api/company-api";
import { UserApi as UserApiV2 } from "@/api-v2/settings-storage/api/user-api";
import { DocumentNumberApi as DocumentNumberApiV2 } from "@/api-v2/document-number/api/document-number-api";
import { CourseRegistrationApi } from "@/api-v2/course/api/course-registration-api";
import { StudentApi } from "@/api-v2/course/api/student-api";
import { CourseApi as CourseApiV2 } from "@/api-v2/course/api/course-api";
import { CourseInfoApi as CourseInfoApiV2 } from "@/api-v2/course/api/course-info-api";
import { CourseDocumentInfoApi as CourseDocumentInfoApiV2 } from "@/api-v2/course-document-info/api/course-document-info-api";
import { LearningProgressApi } from "@/api-v2/course/api/learning-progress-api";
import { AttachmentApi } from "@/api-v2/course/api/attachment-api";
import { ScormApi } from "@/api-v2/scorm/api/scorm-api";
import { ScormLearningProgressApi } from "@/api-v2/scorm/api/scorm-learning-progress-api";
import { RequestApi } from "@/api-v2/learning-requests/api/request-api";
import { ActionApi } from "@/api-v2/learning-requests/api/action-api";
import { StatusProfileApi } from "@/api-v2/learning-requests/api/status-profile-api";
import { StudentApi as StudentDocumentInfoApi } from "@/api-v2/student-document-info/api/student-api";
import { GroupApi as LearningGroupApi } from "@/api-v2/learning-group/api/group-api";
import { BillApi as DGBillApi } from "@/api-v2/document-generator/api/bill-api";
import { ActApi as DGActApi } from "@/api-v2/document-generator/api/act-api";
import { TemplateFilesApi as DGTemplateFilesApi } from "@/api-v2/document-generator/api/template-files-api";
import { ContractApi as DGContractApi } from "@/api-v2/document-generator/api/contract-api";
import { EducationProtocolApi as DGEducationProtocolApi } from "@/api-v2/document-generator/api/education-protocol-api";
import { EnrollmentOrderApi as DGEnrollmentOrderApi } from "@/api-v2/document-generator/api/enrollment-order-api";
import { ExpulsionOrderApi as DGExpulsionOrderApi } from "@/api-v2/document-generator/api/expulsion-order-api";
import { FinalDocumentApi as DGFinalDocumentApi } from "@/api-v2/document-generator/api/final-document-api";
import { CategoryApi as DGCategoryApi } from "@/api-v2/category/api/category-api";
import { ImportApi } from "@/api-v2/import-export/api/import-api";
import { ContractorApi as ImportContractorApi } from "@/api-v2/import-export/api/contractor-api";
import { UserApi as UserImportApi } from "@/api-v2/import-export/api/user-api";
import { AgentApi } from "@/api-v2/agent/api/agent-api";
import { ConditionApi } from "@/api-v2/agent/api/condition-api";
import { AccessApi } from "@/api-v2/service-access/api/access-api";
import {
  ImportApi as ImportApi2,
  ExportApi as ExportApi2
} from "@/api-v2/import-export-2/api";
import {
  NotificationApi,
  CompanyApi as NotificationCompanyApi,
  UserApi as NotificationUserApi
} from "@/api-v2/notification/api";
import {
  CourseApi as LaborProtectionCourseApi,
  EducationProtocolApi as LaborProtectionEducationProtocolApi,
  WorkerApi as LaborProtectionWorkerApi
} from "@/api-v2/labor-protection/api";
import { authApi } from "@/getinfo-api/auth";
import { envVars } from "@/plugins/env-vars";
import { i18n } from "@/locales/settings";
import {
  setAuthTokens,
  isLoggedIn,
  getAccessToken,
  clearAuthTokens
} from "axios-jwt";
import router from "@/router";

// Init axios
export const axios: AxiosInstance = Axios.create({
  baseURL: envVars.get("VUE_APP_API_HOST")
});

axios.interceptors.request.use(config => {
  config.headers["Accept-Language"] = i18n.locale ?? "ru-RU";

  const route = document.location.pathname;

  const notAuthorizedRoutes = [
    "/password-recovery",
    "/login",
    "/agreement-not-logged"
  ];

  const isAuthorizedRoute = !notAuthorizedRoutes?.includes(route);

  const isTokenExist = !!getAccessToken();

  if (isAuthorizedRoute && (!isTokenExist || !isLoggedIn())) {
    router.push({ name: "logout" });
  }

  return config;
});

axios.interceptors.response.use(
  config => {
    return config;
  },
  error => {
    if (error.response && error.response.status === 401) {
      clearAuthTokens();
      router.push({ name: "login" });
      return Promise.reject(error);
    }

    if (
      error.response &&
      error.response.data &&
      error.response.data.code &&
      error.response.data.code === 403 &&
      error.response.data.returnToAccessUserId
    ) {
      const lsToken = localStorage.getItem("backToken");
      if (lsToken) {
        const backToken = JSON.parse(lsToken) as {
          accessToken: string;
          refreshToken: string;
        };
        setAuthTokens({
          accessToken: backToken.accessToken,
          refreshToken: backToken.refreshToken
        });
        localStorage.removeItem("backToken");
        location.reload();
      }
    }
    return Promise.reject(error);
  }
);

// Export freeze api object
const api = Object.freeze({
  AuthApi: authApi,
  UsersApi: new UsersApi({}, "", axios),
  CompanyApi: new CompanyApi({}, "", axios),
  CourseApi: new CourseApi({}, "", axios),
  CourseLectureApi: new CourseLectureApi({}, "", axios),
  LectureApi: new LectureApi({}, "", axios),
  LectureExtraMaterialApi: new LectureExtraMaterialApi({}, "", axios),
  LecturePageApi: new LecturePageApi({}, "", axios),
  LectureSlideApi: new LectureSlideApi({}, "", axios),
  LectureVideoApi: new LectureVideoApi({}, "", axios),
  AccessCheckApi: new AccessCheckApi({}, "", axios),
  TestApi: new TestApi({}, "", axios),
  TestPassApi: new TestPassApi({}, "", axios),
  VideoApi: new VideoApi({}, "", axios),
  PracticeApi: new PracticeApi({}, "", axios),
  BBBWebinarApi: new BBBWebinarApi({}, "", axios),
  CategoryApi: new CategoryApi({}, "", axios),
  CompanyFileApi: new CompanyFileApi({}, "", axios),
  FileApi: new FileApi({}, "", axios),
  ThirdPartyWebinarApi: new ThirdPartyWebinarApi({}, "", axios),
  UserFileApi: new UserFileApi({}, "", axios),
  WebinarApi: new WebinarApi({}, "", axios),
  LearningRequestApi: new LearningRequestApi({}, "", axios),
  EmployeeApi: new EmployeeApi({}, "", axios),
  ContractorApi: new ContractorApi({}, "", axios),
  ActApi: new ActApi({}, "", axios),
  BillApi: new BillApi({}, "", axios),
  ContractApi: new ContractApi({}, "", axios),
  EducationProtocolApi: new EducationProtocolApi({}, "", axios),
  EnrollmentOrderApi: new EnrollmentOrderApi({}, "", axios),
  ExpulsionOrderApi: new ExpulsionOrderApi({}, "", axios),
  FinalDocumentApi: new FinalDocumentApi({}, "", axios),
  ApplicationApi: new ApplicationApi({}, "", axios),
  ProfessionalActivityTaxonomyApi: new ProfessionalActivityTaxonomyApi(
    {},
    "",
    axios
  ),
  ProfessionalProgramTaxonomyApi: new ProfessionalProgramTaxonomyApi(
    {},
    "",
    axios
  ),
  SpecialtyTaxonomyApi: new SpecialtyTaxonomyApi({}, "", axios),
  WidgetApi: new WidgetApi({}, "", axios),
  DocTemplateApi: new DocTemplateApi({}, "", axios),
  DocumentTypeTaxonomyApi: new DocumentTypeTaxonomyApi({}, "", axios)
});

const V2_PREFIX = "/v2";

export const fileApi = Object.freeze({
  FileApiV2: new FileApiV2({}, V2_PREFIX, axios),
  DiskApi: new DiskApiV2({}, V2_PREFIX, axios),
  ConvertApi: new ConvertApi({}, V2_PREFIX, axios)
});

export const settingStorageApi = Object.freeze({
  Global: new GlobalApiV2({}, V2_PREFIX, axios),
  Company: new CompanyApiV2({}, V2_PREFIX, axios),
  User: new UserApiV2({}, V2_PREFIX, axios)
});

export const courseApi = Object.freeze({
  Course: new CourseApiV2({}, V2_PREFIX, axios),
  Student: new StudentApi({}, V2_PREFIX, axios),
  CourseRegistration: new CourseRegistrationApi({}, V2_PREFIX, axios),
  LearningProgress: new LearningProgressApi({}, V2_PREFIX, axios),
  CourseInfo: new CourseInfoApiV2({}, V2_PREFIX, axios),
  CourseDocumentInfo: new CourseDocumentInfoApiV2({}, V2_PREFIX, axios),
  Attachment: new AttachmentApi({}, V2_PREFIX, axios)
});

export const scormApi = Object.freeze({
  Scorm: new ScormApi({}, V2_PREFIX, axios),
  ScormLearningProgress: new ScormLearningProgressApi({}, V2_PREFIX, axios)
});

export const documentNumberApi = new DocumentNumberApiV2({}, V2_PREFIX, axios);

export const learningRequestApi = Object.freeze({
  Request: new RequestApi({}, V2_PREFIX, axios),
  Action: new ActionApi({}, V2_PREFIX, axios),
  StatusProfiles: new StatusProfileApi({}, V2_PREFIX, axios)
});

export const studentDocumentApi = new StudentDocumentInfoApi(
  {},
  V2_PREFIX,
  axios
);

//@TODO Обновить
export const importCsvApi = Object.freeze({
  Contractor: new ImportContractorApi({}, V2_PREFIX, axios),
  ImportApi: new ImportApi({}, V2_PREFIX, axios),
  UserImportApi: new UserImportApi({}, V2_PREFIX, axios)
});

export const learningGroupsApi = Object.freeze({
  Group: new LearningGroupApi({}, V2_PREFIX, axios)
});

export const agentApi = Object.freeze({
  Agent: new AgentApi({}, V2_PREFIX, axios),
  Condition: new ConditionApi({}, V2_PREFIX, axios)
});

export const accessApi = Object.freeze({
  Access: new AccessApi({}, V2_PREFIX, axios)
});

export const categoryApi = Object.freeze({
  category: new DGCategoryApi({}, V2_PREFIX, axios)
});

export const documentGeneratorApi = Object.freeze({
  Bill: new DGBillApi({}, V2_PREFIX, axios),
  Act: new DGActApi({}, V2_PREFIX, axios),
  TemplateFiles: new DGTemplateFilesApi({}, V2_PREFIX, axios),
  Contract: new DGContractApi({}, V2_PREFIX, axios),
  EducationProtocol: new DGEducationProtocolApi({}, V2_PREFIX, axios),
  EnrollmentOrder: new DGEnrollmentOrderApi({}, V2_PREFIX, axios),
  ExpulsionOrder: new DGExpulsionOrderApi({}, V2_PREFIX, axios),
  FinalDocument: new DGFinalDocumentApi({}, V2_PREFIX, axios)
});

export const notificationApi = Object.freeze({
  Notification: new NotificationApi({}, V2_PREFIX, axios),
  User: new NotificationUserApi({}, V2_PREFIX, axios),
  Company: new NotificationCompanyApi({}, V2_PREFIX, axios)
});

export const laborProtectionApi = Object.freeze({
  Course: new LaborProtectionCourseApi({}, V2_PREFIX, axios),
  EducationProtocol: new LaborProtectionEducationProtocolApi(
    {},
    V2_PREFIX,
    axios
  ),
  Worker: new LaborProtectionWorkerApi({}, V2_PREFIX, axios)
});

export const importExportApi = Object.freeze({
  Import: new ImportApi2({}, V2_PREFIX, axios),
  Export: new ExportApi2({}, V2_PREFIX, axios)
});

export default api;
